import { Col, Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import CategoryInfoItem from "./categoryInfoItem";
import "./style.scss";
import _ from "lodash";
import { WIDTH_IPAD } from "../../common/constant";
import { ISectionCSS } from "../../models/interface/ISectionCSS";
import {
  getImageOrVideoPath,
  handleChangeIntersection,
} from "../../shared/helpers";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import InView from "react-intersection-observer";

gsap.registerPlugin(ScrollTrigger);

const CategoryDescription = (props: any) => {
  const {
    sectionItem,
    isCategoriesParent,
    history,
    isNeedScrollTrigger,
    isShowHome,
  } = props;
  const { innerWidth, innerHeight } = window;
  const sectionId = sectionItem._id.toString();
  const sectionRef: any = useRef(null);
  const [tl, setTl] = useState<any>();

  if (isNeedScrollTrigger && tl && innerWidth > WIDTH_IPAD) {
    tl.scrollTrigger.refresh(true);
  }

  useEffect(() => {
    if (
      sectionRef &&
      sectionRef.current &&
      isNeedScrollTrigger &&
      innerWidth > WIDTH_IPAD
    ) {
      const tl: any = gsap.timeline({
        scrollTrigger: {
          trigger: ".kd-category-description-child",
          // trigger: ".kd-categories-info",
          start: "top 170px",
          end: () => "+=" + (sectionRef.current?.offsetHeight || innerHeight),
          scrub: 1.5,
          pin: true,
          anticipatePin: 1,
          // markers: true,
        },
      });
      setTl(tl);
    }
  }, []);

  const showChildren = (data: any) => {
    const rs = data.map((d: any, i: number) => (
      <Col
        key={i}
        className={`kd-category-info ${
          d.video && d.video.length && innerWidth > WIDTH_IPAD
            ? "kd-category-info-hover"
            : ""
        }`}>
        <InView
          triggerOnce
          onChange={(inView, entry) => {
            if (innerWidth < WIDTH_IPAD && isShowHome) {
              handleChangeIntersection(inView, entry, "img-animation");
            }
          }}>
          <CategoryInfoItem
            isShowHome={isShowHome}
            isNeedScrollTrigger={isNeedScrollTrigger}
            tl={tl}
            categoryInfo={d}
            index={i}
            isCategoriesParent={isCategoriesParent}
            history={history}
          />
        </InView>
      </Col>
    ));

    if (data.length % 2 != 0) {
      rs.push(
        <Col key={data.length} className="kd-category-info item-hidden">
          <CategoryInfoItem
            categoryInfo={data[data.length - 1]}
            index={data.length}
            isCategoriesParent={isCategoriesParent}
            history={history}
          />
        </Col>
      );
    }

    return rs;
  };

  const colorStyle: ISectionCSS = {
    "--colorTitle": sectionItem.color_title
      ? sectionItem.color_title
      : "#0c3b5d",
    "--colorSubTitle": sectionItem.color_sub_title
      ? sectionItem.color_sub_title
      : "#0c3b5d",
    "--colorContent": sectionItem.color_content
      ? sectionItem.color_content
      : "#0c3b5d",
  };

  return sectionItem ? (
    <>
      <div
        id={sectionId}
        style={{
          height: 160,
          marginTop: -160,
          display: "block",
          visibility: "hidden",
        }}></div>

      <Row
        justify="center"
        className="kd-category-description-container"
        style={{
          backgroundColor: sectionItem.background_color,
          backgroundImage:
            sectionItem.background_image &&
            sectionItem.background_image.length &&
            `url(${sectionItem.background_image[0].galaries[0].path})`,
        }}>
        {sectionItem.background_video && sectionItem.background_video.length ? (
          <video autoPlay muted loop id="bgVideo">
            <source
              src={sectionItem.background_video[0].galaries[0].path}
              type="video/mp4"
            />
          </video>
        ) : null}
        {sectionItem.video && sectionItem.video.length ? (
          <div className="kd-category-description-parent-gif">
            <img src={getImageOrVideoPath(sectionItem.video)} alt="" />
          </div>
        ) : (
          <div className="kd-category-description-parent">
            <Row
              className="kd-category-description-parent-title large-title"
              justify="center"
              style={colorStyle}>
              {sectionItem.title}
            </Row>
            <Row
              className="kd-category-description-parent-sub-title"
              justify="center"
              style={colorStyle}>
              <div
                dangerouslySetInnerHTML={{
                  __html: sectionItem.sub_title,
                }}
              />
            </Row>
            {sectionItem.content ? (
              <Row
                className="kd-category-description-parent-content"
                justify="center"
                style={colorStyle}>
                {sectionItem.content}
              </Row>
            ) : null}
          </div>
        )}
        <div className="kd-category-description-child">
          <Row
            wrap
            className="kd-categories-info"
            justify="center"
            ref={sectionRef}>
            {sectionItem.children && sectionItem.children.length
              ? showChildren(_.sortBy(sectionItem.children, ["order"]))
              : null}
          </Row>
        </div>
      </Row>
    </>
  ) : null;
};

export default CategoryDescription;
